import {createRouter, createWebHistory} from 'vue-router'
import NProgress from 'nprogress'//引入nprogress
// import 'nprogress/nprogress.css' //这个样式必须引入
import store from '../store'

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('@/views/index')
    },
    // {
    //     path: '/liangchang',
    //     name: 'liangchang',
    //     component: () => import('@/views/liang')
    // },
    {
        path: '/live',
        name: 'live',
        component: () => import('@/views/live')
    },
    {
        path: '/penlin',
        name: 'penlin',
        component: () => import('@/views/penlin')
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/404',
        children: [
            {
                path: '/404', // 这里要加上/404,和上面的redirect对应,必须加上/
                name: '404',
                component: () => import('@/views/error'),
            },
        ],
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    // console.log(to.meta.keepAlive)
    if(to.meta.keepAlive === undefined){
        to.meta.keepAlive = true
    }
    // console.log('admin')    
    // let that = this    
    // if(to.name.indexOf('mglogin') === -1 || to.name.indexOf('maginc') === -1) {
    //     console.log('front')
        
    //     next()
        // return
    // }
    if(to.meta.authen){
        // window.document.title = '后台管理 | 海东制梁厂智慧指挥中心'
        // if(to.name === 'mglogin'){
        //     if(store.getters.isLogin){
        //         next({path: '/maginc/producePlan'})
        //         // console.log('去首页')
        //     }
        // }
        // else{
        //     if(!store.getters.isLogin){
        //         next({path: '/mglogin'})
        //         // console.log('去登录')
        //     }
        // }
    }
    else
        window.document.title = '海东制梁厂智慧指挥中心'
    next()
})

router.afterEach((to, from, next)=>{
    NProgress.done()
    // console.log(to.meta)
})

export default router
